module.exports = __webpack_public_path__ + "img/logo_jata.dd52b3f7.png";